import React from "react";
import styled from "styled-components";
import _ from "lodash";
import Select from "react-select";
import { FormHelperText, FormControl, InputLabel, MenuItem } from "@material-ui/core";

const TinyHelper = styled.div`
  color: #999;
  position: absolute;
  top: -13px;
  z-index: 5;
  font-size: 11px;
`;
const selectStyles = {
  container: (provided, state) => ({
    ...provided,
    borderBottom: "1px solid #2196F3",
    transition: "border 0.1s",
    "&:hover": {
      cursor: "pointer",
      borderBottom: "1px solid #43A8FF"
    },
    padding: "0"
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: "0",
    cursor: "pointer"
  }),
  indicatorSeparator: (provided, state) => ({
    display: "none"
  }),
  placeholder: (provided, state) => ({
    color: "#999",
    padding: 0,
    position: "absolute",
    top: "9px"
  }),
  control: (provided, state) => ({
    ...provided,
    boxShadow: "none",
    border: "none",
    padding: 0

  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: 6
  })
};
const addErrorStyles = (currentSelectStyles, error, touched, required) => {
  if (Boolean(error) && touched && required) {
    currentSelectStyles.placeholder = (provided, state) => ({
      color: "red",
      padding: 0,
      position: "absolute",
      top: "9px"
    });
    currentSelectStyles.container = (provided, state) => ({
      ...provided,
      borderBottom: "1px solid red",
      transition: "border 0.1s",
      "&:hover": {
        cursor: "pointer",
        borderBottom: "1px solid red"
      },
      padding: "0"
    });
  }
};
const addSelectedOptionStyles = (currentSelectStyles, placeholder) => {
  if (placeholder) {
    currentSelectStyles.placeholder = (provided, state) => ({
      color: "#000",
      padding: 0,
      position: "absolute",
      top: "9px"
    });
  }
};
const ConfigItemSelect = ({ id, values, fieldName, label, options, handleChange, rootClassName, error, touched, required, ...other }) => {
  const currentSelectStyles = { ...selectStyles };
  const placeholder = _.find(options, { id: values[fieldName] });
  const sortedOptions = _.sortBy(options, ["sortOrder", "name"]);
  addErrorStyles(currentSelectStyles, error, touched, required);
  addSelectedOptionStyles(currentSelectStyles, placeholder);

  return (
    <FormControl classes={{ root: rootClassName }} required={required}>
      {placeholder && <TinyHelper>{label}</TinyHelper>}
      <Select
        id={id}
        isSearchable
        styles={currentSelectStyles}
        error={Boolean(error) && touched}
        placeholder={placeholder ? placeholder.name : label}
        value={values[fieldName]}
        onChange={(a, b) => {
          handleChange(
            {
              target:
            {
              name: fieldName,
              value: a.value
            }
            }
          );
        }}
        options={sortedOptions.map(x => ({
          label: x.name,
          value: x.id
        }))}
        {...other}
      />
      {Boolean(error) && touched && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
export default ConfigItemSelect;
